import Model from "@/lib/model/model";
import {
  EnumQuestionType,
  QuestionV2
} from "@/lib/model/exambuilder/question-v2";
import { ReportConfig } from "./report";
import { ApplicationRule, ApplicationRuleNew } from "./application-rule";
import {
  BgCheck,
  BgCheckConfig,
  CertPhotoCapture,
  CertPhotoCaptureConfig,
  ColorDetection,
  DescAfter,
  DescAfterConfig,
  DescBefore,
  DescBeforeConfig,
  DeviceDetection,
  Game,
  HandDetection,
  IntelligentQA,
  JumpOutConfig,
  JumpOutDetection,
  LivenessRecognition,
  NameIdCheck,
  LivenessRecognitionConfig,
  PrivacyConfig,
  Publicity,
  PublicityConfig,
  FaceConfig,
  VideoDetection,
  FaceDetection,
  FaceAssessment,
  ScreenshotConfig,
  ScreenshotDetection,
  WatermarkConfig,
  QuestionnaireConfig,
  TestExam,
  ChannelConfig,
  SignatureConfig,
  VrGuideConfig,
  WorkLocation,
  ResumeParse,
  BodyDetection
} from "./component";
import { Dimension, DimensionConfig, DimensionGroup } from "./dimension";
import {
  AskConfig,
  DimensionScore,
  OptionScore,
  Question,
  QuestionConfig,
  QuestionItem,
  RandomConfig
} from "./question";
import { TacPsyc, TacPsycConfig } from "./tac-psyc";
import {
  ExamV2Custom,
  FingerConfig,
  StructExamQuestionConfig,
  StructExamRandomConfig,
  TacMindConfig
} from "@/lib/model/exambuilder/exam-v2";
import { ThousandsComponent } from "./thousands-question";
import { Param, ParamComponent } from "./params";
import request from "@/lib/request/request";
import { VirConfig } from "./vir";
import dayjs from "dayjs";
import { TacMind } from "@/lib/model/exambuilder/exam-component/company";
import { NonessentialComponent } from "@/lib/model/exambuilder/exam-component/common";

export enum SectionPageType {
  Color,
  Psyc,
  Finger,
  Face,
  Questions,
  Body
}

export class CheckConfig extends Model {
  title = "";
  text = "";
  buttonText = "";
}

export class SectionConfig extends Model {
  needSectionPage = true;
  sectionKey = "";
  sectionType = 1;
  sectionName = "";
  title = "";
  text = "";
  buttonText = "";
  imgUrlList: string[] = [];
  videoUrl = "";
  audioUrl = "";
  needCheckToBegin = false;
  checkConfig = new CheckConfig();

  public objectArrayClasses() {
    return {
      imgUrlList: ""
    };
  }
}

export class Section extends NonessentialComponent {
  type = 1; // 环节介绍类型 1:图文版 2:视频版
}

export class CustomPageConfig extends Model {
  showWay = 2; // 自定义页面类型 1:自定义视频 2:文本生成视频 3:文本默认封面 4:文本自定义封面 5:纯文本
  videoUrl = ""; // 视频链接
  videoCoverUrl = ""; // 封面链接
  title = ""; // 标题
  text = ""; // 内容
  videoMustPlay = false; // 视频是否强制播放
  videoMustPlayText = "须完整观看视频"; // 视频强制播放提示文案
  needProcessBar = false; // 视频是否需要展示进度条
  fillType = 0; // 视频填充类型 0:横视频 1:竖视频
  textAlign = 0; // 文字布局类型 0:居中 1:居左 2:居右
  buttonText = "下一步"; // 自定义按钮名称
  buttonDurationSecond = 0; // 非视频类型点击按钮倒计时限制
  virMakerVideoId = 0; // 虚拟视频任务id(冗余)
  positionType = 1; // 前端冗余(自定义页位置) 1:须知页前 2:须知页后 3:信息登记前 4:信息登记后 5:题目中
}

export class CustomPage extends NonessentialComponent {
  sortType = "component"; // 自定义页排序类型 "component" "question" "tacPsyc"
  componentSort = 0;
  componentClassification = 3; // 组件分类 1:签到前-流程组件 3:签到后-流程组件
  configData = new CustomPageConfig();

  // 前端字段
  fold = false;
  questionSort = 1;
}

export class JobDetail extends Model {
  outJobId = ""; // 三方岗位id
  title = ""; // 标题
  desc = ""; // 描述
  industry = ""; // 行业
  type = ""; // 分类
  scene = ""; // 场景 1:校招 2:社招 3:蓝领
  duty = ""; // 职责
}

export class MetaInfo extends Model {
  examId = 0;
  connectCode = "";
  connectCodeForInvite = ""; // 3开头的码，二维码定向邀请码
  companyId = 0;
  examVersionId = 0;
  examVersionIndex = 0;
  createdTime = "";
  lastUpdateTime = "";
  hasCandidate = true;
}

export class ExamInfo extends Model {
  name = "";
  remark = "";
  positionId = 0;
  positionName = "";
  innerName = "";
  templatePositionId = 0;
  templateCode = "";
  jobDetail = new JobDetail();
  examCreatedType = 0;
}

export class LoginConfig extends Model {
  loginType = 1;
  paramSkipType = 1;
  loginBgUrl = "";
}

export class ExamVersionInfo extends Model {
  questionNumber = 0;
  useTimeSecond = 0;
  lang = 0; // 0 中文 1 英文
  scoreAll = 0;
  timeLimitConfig = new TimeLimitConfig();
  repeatAnswerConfig = new RepeatAnswerConfig();
  reportConfig = new ReportConfig();
  styleConfig = new StyleConfig();
  applicationRule: ApplicationRuleNew = new ApplicationRuleNew();
  applicationRuleList: ApplicationRule[] = [];
  virConfig = new VirConfig();
  scoreConfig = new ScoreConfig();
  replacementDetection = new VideoDetection();
  faceDetection = new FaceDetection();
  faceAssessment = new FaceAssessment();
  faceShowDetection = new VideoDetection();
  multiplePersonDetection = new VideoDetection();
  watermark = new WatermarkConfig();
  screenshotDetection = new ScreenshotDetection();
  jumpOutDetection = new JumpOutDetection();
  colorDetection = new ColorDetection();
  handDetection = new HandDetection();
  bodyDetection = new BodyDetection();
  certPhotoCapture = new CertPhotoCapture();
  signatureConfig = new SignatureConfig();
  livenessRecognition = new LivenessRecognition();
  nameIdCheck = new NameIdCheck();
  bgCheck = new BgCheck();
  paramList: Param[] = [];
  params = new ParamComponent().assign({
    use: 1
  });
  loginConfig = new LoginConfig();
  paramsSaveLater = new ParamComponent();
  intelligentQa = new IntelligentQA();
  dimensions = new Dimension();
  questions = new Question();
  tacPsycGauge = new TacPsyc();
  game = new Game();
  deviceDetection = new DeviceDetection();
  hairDetection = new NonessentialComponent();
  dressingDetection = new NonessentialComponent();
  smokeDetection = new NonessentialComponent();
  multiVoiceDetection = new NonessentialComponent();
  keyboardSoundDetection = new NonessentialComponent();
  versionDetection = new NonessentialComponent().assign({
    use: 1
  });
  networkDetection = new NonessentialComponent().assign({
    use: 1
  });
  questionnaireConfig = new QuestionnaireConfig();
  channelConfig = new ChannelConfig();
  descBefore = new DescBeforeConfig();
  descAfter = new DescAfterConfig();
  privacyConfig = new PrivacyConfig();
  publicityPageConfig = new PublicityConfig();
  thousandsTask = new ThousandsComponent();
  testExamConfig = new TestExam();
  customPageConfigList: CustomPage[] = [];
  sectionPageConfig = new Section().assign({
    use: 1,
    type: 1
  });

  // 前端字段
  allParams: Param[] = [];
  defaultParams: Param[] = [];
  questionSelectedList: QuestionV2[] = [];
  aiAsk = new NonessentialComponent();
  vrGuideConfig = new VrGuideConfig();
  workLocationConfig = new WorkLocation();
  resumeParseConfig = new ResumeParse();
  readingDetection = new NonessentialComponent();

  constructor() {
    super();

    const hasAppendAsk = this.questions.questionConfigList.some(item => {
      return item.appendAskConfig.enableAppendAsk === 1;
    });
    this.aiAsk.use = hasAppendAsk ? 1 : 2;
  }

  public objectArrayClasses() {
    return {
      paramList: Param,
      allParams: Param,
      defaultParams: Param,
      applicationRuleList: ApplicationRule,
      questionSelectedList: QuestionV2,
      customPageConfigList: CustomPage
    };
  }

  get examTakeTime() {
    let second = 0;
    if (this.questions.isRandomQuestion === 1) {
      // 抽题组卷
      this.questions.randomConfigList.forEach(questionGroup => {
        // 抽题组卷根据每组配置的题目类型与抽题数量算时长
        const n = questionGroup.questionIdList.length;
        if (
          questionGroup.questionType === 1 ||
          questionGroup.questionType === 5
        ) {
          //选择填空题耗时  30s
          second += n * 30;
        } else {
          // 视频音频 同普通
          second += n * 30;
          second += n * 10;
          second += n * 3 * 60;
        }
      });
    } else {
      this.questions.questionConfigList.forEach((q, i: number) => {
        if (
          q.questionType === EnumQuestionType.EnumQuestionTypeSingleChoice ||
          q.questionType === EnumQuestionType.EnumQuestionTypeBlanks
        ) {
          //选择题/填空题耗时  30s
          second += 1 * 30;
        } else {
          //视频题耗时  题干30s 其他看配置
          second += 1 * 30;
          second += q?.preparationTime > 0 ? q?.preparationTime : 1 * 10;
          second += q?.answerTime > 0 ? q?.answerTime : 3 * 60;
        }
      });
    }
    //各类配置耗时
    second += this.colorDetection.use === 1 ? 1 * 60 : 0;
    second +=
      this.tacPsycGauge.use === 1
        ? this.tacPsycGauge.configDataList.length * 60
        : 0;
    second += this.handDetection.use === 1 ? 1 * 60 : 0;
    second += this.bgCheck.use === 1 ? 1 * 10 : 0;
    second += this.livenessRecognition.use === 1 ? 1 * 60 : 0;
    return Math.ceil(second / 60);
  }
}

export class TimeLimitConfig extends Model {
  noEnding = 1; // 是否面试有效期长期有效
  beginTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"); // 面试开始时间
  endTime = ""; // 面试有效期固定期限面试结束时间
  timeLimitGiveUp = 0; // 自动过期时间(秒)
  giveUpSignIn = 1; // 已签到是否自动过期
  giveUpNotSignIn = 1; // 未签到是否自动过期
  timeLimitExamType = 1; // 答题时间限制类型 1:24h 2:自定义时间 3:基于结束时间
  timeLimitExam = 86400; // 答题时间限制(秒)
  examRegisterEndTime = ""; // 登记截止时间
  timeLimitExamTemp = 0;
  examExpireTextMessage = 0; // 面试过期提示提示语
  canOpenJoin = 1; // 是否允许公开邀请
  isNoCreateOpenJoin = 0; // 是否公开邀请流程禁止新建候选人

  // 面试有效期文本
  get interviewValidityPeriod() {
    const tipText = "待选择";

    if (this.noEnding === 1) {
      return "长期有效";
    } else {
      const startTime = `${this.beginTime ? this.beginTime : tipText}`;
      const endTime = `${this.endTime ? this.endTime : tipText}`;

      return `${startTime} ~ ${endTime}`;
    }
  }
}

export class RepeatAnswerConfig extends Model {
  repeatAnswerLimit = 1;
  repeatAnswerDayLimit = 0;
}

export class StyleConfig extends Model {
  mainColor = "#525fff";
  coverColor = "#F1F2FF";
  shadowColor = "rgba(92, 45, 255, 0.23)";
  backgroundColor = {
    from: "#525fff",
    to: "#606DFC"
  };
  showLogo = false;
  fontSize = 16;
  fontWeight = false;
  needProcessBar = 1;
  logoUrl = "";
  sectionPageType = 2;
}

export enum AiType {
  EnumAiTypeRegex = 0, // 使用正则进行打分
  EnumAiTypeHinaGlmCheckPoint = 3, // Hina1_v1.1
  EnumAiTypeHinaGlmCheckPointV2 = 5, // Hina1_v1.2
  EnumAiTypeHinaGlmCheckPointDev = 6, // HinaDev(研发专用)
  EnumAiTypeHinaGlmCheckPointV2HW = 7, // Hina1_v1.3
  EnumAiTypeHina2V1 = 8 // Hina2_v1
}

export class ScoreConfig extends Model {
  examScene = 0; // 面试场景 0: 通用 1:校招 2:社招
  appendScorePercent = 0; // 追问得分系数
  autoMark = 0; // 是否自动审核
  aiType = AiType.EnumAiTypeRegex; // ai模型： 0 3 5 6 7 8
}

export class ExamUpdateName extends Model {
  examId = 0;
  name = "";
  remark = "";
  positionId = 0;
}

export class ExamComponent extends Model {
  metaInfo = new MetaInfo();
  examInfo = new ExamInfo();
  examVersionInfo = new ExamVersionInfo();
  isTesting = false; // 测试模式标记

  static getDefaultSectionPage(type: SectionPageType, psyc?: TacMind) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "辨色检测",
          title: "接下来将进行辨色检测",
          text:
            "请根据卡片上的数字或图案，选择相应的答案。<br/>本组为限时作答题目，请在系统提示的时间内作答，否则将自动跳转下一题。",
          buttonText: "开始",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `下面进行${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "开始测评",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "手部检测",
          needSectionPage: true, //是否需要sectionPage
          sectionKey: "handDetection", //section唯一标识（新增）
          sectionType: 1, //section类型 图文 1 视频 2
          title: "下面进入手部检测环节", //section标题
          text:
            "请观看手部检测指引视频，做好准备后，点击下方按钮，进行手部检测", //section说明文案
          buttonText: "准备好了，开始检测", //按钮文字
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ] //轮播图片 （type1时使用）
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "形体检测",
          needSectionPage: true,
          sectionKey: "bodyDetection", //section唯一标识（新增）
          sectionType: 1, //section类型 图文 1 视频 2
          title: "下面进入形体检测环节", //section标题
          text:
            "接下来我们将拍摄到您身体的以下部位:正面全身,正面手臂平举,侧面下蹲,左侧高抬腿,右侧高抬腿。请将手机音量调大,靠在墙边,立在地面上。点击开始检测,进入拍摄环节。点击重新播放,可重新观看视频", //section说明文案
          buttonText: "准备好了，开始检测" //按钮文字
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "脸部检测",
          needSectionPage: true, //是否需要sectionPage
          sectionKey: "faceDetection", //section唯一标识（新增）
          sectionType: 1, //section类型 图文 1 视频 2
          title: "下面进入脸部检测环节", //section标题
          text:
            "请仔细阅读下方的图片说明，准备好后，请点击下方按钮，进行脸部检测", //section说明文案
          buttonText: "准备好了，开始检测", //按钮文字
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ] //轮播图片 （type1时使用）
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "能力考察",
          title: "下面请回答面试官的问题",
          text: "下面请回答面试官的问题",
          buttonText: "点击立即开始",
          imgUrlList: []
        });
      }
    }
  }
  // !临时方案，英文的默认配置
  static getDefaultSectionPageForEnglish(
    type: SectionPageType,
    psyc?: TacMind
  ) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "Color Detection",
          title: "Next, we will conduct a color detection test",
          text:
            "Please select the answer based on the numbers or patterns on the card.<br/>This group has a time limit; answer within the given time, or it will automatically proceed to the next question.",
          buttonText: "Start",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `Next, we will conduct ${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "Start Assessment",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "Body Detection",
          needSectionPage: true,
          sectionKey: "bodyDetection", //section唯一标识（新增）
          sectionType: 1, //section类型 图文 1 视频 2
          title: "Next, we will enter the body detection phase", //section标题
          text:
            "Please watch the hand detection guide video, and after preparing, click the button below to conduct the body detection", //section说明文案
          buttonText: "Ready, Start Detection" //按钮文字
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "Hand Detection",
          needSectionPage: true, // Whether section page is needed
          sectionKey: "handDetection", // Unique identifier for the section (new)
          sectionType: 1, // Section type: 1 for image and text, 2 for video
          title: "Next, we will enter the hand detection phase", // Section title
          text:
            "Please watch the hand detection guide video, and after preparing, click the button below to conduct the hand detection", // Section description
          buttonText: "Ready, Start Detection", // Button text
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ] // Carousel images (used when type is 1)
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "Face Detection",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title: "Next, we will enter the face detection phase", // Section title
          text:
            "Please carefully read the image instructions below, and after preparing, click the button below to conduct the face detection", // Section description
          buttonText: "Ready, Start Detection", // Button text
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ] // Carousel images (used when type is 1)
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "Ability Evaluation",
          title: "Please answer the questions from the interviewer",
          text: "Please answer the questions from the interviewer",
          buttonText: "Answer Now",
          imgUrlList: []
        });
      }
    }
  }

  // !马来语的默认配置
  static getDefaultSectionPageForMalay(type: SectionPageType, psyc?: TacMind) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "Pengesanan Warna",
          title: "Seterusnya, kita akan menjalankan ujian pengesanan warna",
          text:
            "Sila pilih jawapan berdasarkan nombor atau corak pada kad.<br/>Kumpulan ini mempunyai had masa; jawab dalam masa yang diberikan, atau ia akan secara automatik meneruskan ke soalan seterusnya.",
          buttonText: "Mula",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `Seterusnya, kita akan menjalankan ${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "Mula Penilaian",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "Pengesanan Badan",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title: "Seterusnya, kita akan memasuki fasa pengesanan badan",
          text:
            "Sila tonton video panduan pengesanan tangan, dan selepas bersedia, klik butang di bawah untuk menjalankan pengesanan badan",
          buttonText: "Bersedia, Mula Pengesanan"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "Pengesanan Tangan",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title: "Seterusnya, kita akan memasuki fasa pengesanan tangan",
          text:
            "Sila tonton video panduan pengesanan tangan, dan selepas bersedia, klik butang di bawah untuk menjalankan pengesanan tangan",
          buttonText: "Bersedia, Mula Pengesanan",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "Pengesanan Muka",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title: "Seterusnya, kita akan memasuki fasa pengesanan muka",
          text:
            "Sila baca dengan teliti arahan imej di bawah, dan selepas bersedia, klik butang di bawah untuk menjalankan pengesanan muka",
          buttonText: "Bersedia, Mula Pengesanan",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "Penilaian Keupayaan",
          title: "Sila jawab soalan daripada penemuduga",
          text: "Sila jawab soalan daripada penemuduga",
          buttonText: "Jawab Sekarang",
          imgUrlList: []
        });
      }
    }
  }

  // !日语的默认配置
  static getDefaultSectionPageForJapanese(
    type: SectionPageType,
    psyc?: TacMind
  ) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "色検出",
          title: "次に、色検出テストを行います",
          text:
            "カード上の数字やパターンに基づいて答えを選んでください。<br/>このグループには時間制限があります。指定された時間内に回答してください。でないと自動的に次の質問に進みます。",
          buttonText: "開始",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `次に、${psyc?.name || ""}を実施します`,
          text: psyc?.introducer || "",
          buttonText: "評価を開始",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "身体検出",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title: "次に、身体検出フェーズに入ります",
          text:
            "手の検出ガイド動画を見て、準備ができたら下のボタンをクリックして身体検出を行ってください",
          buttonText: "準備完了、検出開始"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "手の検出",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title: "次に、手の検出フェーズに入ります",
          text:
            "手の検出ガイド動画を見て、準備ができたら下のボタンをクリックして手の検出を行ってください",
          buttonText: "準備完了、検出開始",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "顔検出",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title: "次に、顔検出フェーズに入ります",
          text:
            "下の画像の指示をよく読み、準備ができたら下のボタンをクリックして顔検出を行ってください",
          buttonText: "準備完了、検出開始",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "能力評価",
          title: "面接官の質問に答えてください",
          text: "面接官の質問に答えてください",
          buttonText: "今すぐ回答",
          imgUrlList: []
        });
      }
    }
  }

  // !越南语的默认配置
  static getDefaultSectionPageForVietnamese(
    type: SectionPageType,
    psyc?: TacMind
  ) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "Kiểm Tra Màu Sắc",
          title: "Tiếp theo, chúng ta sẽ tiến hành kiểm tra màu sắc",
          text:
            "Vui lòng chọn câu trả lời dựa trên số hoặc hình mẫu trên thẻ.<br/>Nhóm này có giới hạn thời gian; trả lời trong thời gian quy định, nếu không hệ thống sẽ tự động chuyển sang câu hỏi tiếp theo.",
          buttonText: "Bắt Đầu",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `Tiếp theo, chúng ta sẽ tiến hành ${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "Bắt Đầu Đánh Giá",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "Nhận Diện Cơ Thể",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title: "Tiếp theo, chúng ta sẽ bước vào giai đoạn nhận diện cơ thể",
          text:
            "Vui lòng xem video hướng dẫn nhận diện tay, và sau khi chuẩn bị, nhấp vào nút bên dưới để tiến hành nhận diện cơ thể",
          buttonText: "Sẵn Sàng, Bắt Đầu Nhận Diện"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "Nhận Diện Tay",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title: "Tiếp theo, chúng ta sẽ bước vào giai đoạn nhận diện tay",
          text:
            "Vui lòng xem video hướng dẫn nhận diện tay, và sau khi chuẩn bị, nhấp vào nút bên dưới để tiến hành nhận diện tay",
          buttonText: "Sẵn Sàng, Bắt Đầu Nhận Diện",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "Nhận Diện Khuôn Mặt",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title:
            "Tiếp theo, chúng ta sẽ bước vào giai đoạn nhận diện khuôn mặt",
          text:
            "Vui lòng đọc kỹ hướng dẫn hình ảnh bên dưới, và sau khi chuẩn bị, nhấp vào nút bên dưới để tiến hành nhận diện khuôn mặt",
          buttonText: "Sẵn Sàng, Bắt Đầu Nhận Diện",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "Đánh Giá Năng Lực",
          title: "Silakan jawab pertanyaan dari pewawancara",
          text: "Silakan jawab pertanyaan dari pewawancara",
          buttonText: "Jawab Sekarang",
          imgUrlList: []
        });
      }
    }
  }

  // !韩语的默认配置
  static getDefaultSectionPageForKorean(type: SectionPageType, psyc?: TacMind) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "색상 감지",
          title: "다음으로, 색상 감지 테스트를 실시합니다",
          text:
            "카드의 숫자나 패턴에 따라 답을 선택해 주세요.<br/>이 그룹은 시간 제한이 있습니다. 주어진 시간 내에 답해 주세요. 그렇지 않으면 자동으로 다음 문제로 넘어갑니다.",
          buttonText: "시작",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `다음으로, ${psyc?.name || ""}을 실시합니다`,
          text: psyc?.introducer || "",
          buttonText: "평가 시작",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "신체 감지",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title: "다음으로, 신체 감지 단계로 들어갑니다",
          text:
            "손 감지 가이드 비디오를 시청하고, 준비가 되면 아래 버튼을 클릭하여 신체 감지를 실시해 주세요",
          buttonText: "준비 완료, 감지 시작"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "손 감지",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title: "다음으로, 손 감지 단계로 들어갑니다",
          text:
            "손 감지 가이드 비디오를 시청하고, 준비가 되면 아래 버튼을 클릭하여 손 감지를 실시해 주세요",
          buttonText: "준비 완료, 감지 시작",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "얼굴 감지",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title: "다음으로, 얼굴 감지 단계로 들어갑니다",
          text:
            "아래 이미지 지침을 주의 깊게 읽고, 준비가 되면 아래 버튼을 클릭하여 얼굴 감지를 실시해 주세요",
          buttonText: "준비 완료, 감지 시작",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "능력 평가",
          title: "면접관의 질문에 답해 주세요",
          text: "면접관의 질문에 답해 주세요",
          buttonText: "지금 답변하기",
          imgUrlList: []
        });
      }
    }
  }

  // !法语的默认配置
  static getDefaultSectionPageForFrench(type: SectionPageType, psyc?: TacMind) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "Détection de Couleur",
          title:
            "Ensuite, nous allons effectuer un test de détection de couleur",
          text:
            "Veuillez sélectionner la réponse en fonction des chiffres ou des motifs sur la carte.<br/>Ce groupe a une limite de temps; répondez dans le temps imparti, sinon le système passera automatiquement à la question suivante.",
          buttonText: "Commencer",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `Ensuite, nous allons effectuer ${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "Commencer l'Évaluation",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "Détection Corporelle",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title:
            "Ensuite, nous allons entrer dans la phase de détection corporelle",
          text:
            "Veuillez regarder la vidéo guide de détection des mains, et après préparation, cliquez sur le bouton ci-dessous pour effectuer la détection corporelle",
          buttonText: "Prêt, Commencer la Détection"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "Détection des Mains",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title:
            "Ensuite, nous allons entrer dans la phase de détection des mains",
          text:
            "Veuillez regarder la vidéo guide de détection des mains, et après préparation, cliquez sur le bouton ci-dessous pour effectuer la détection des mains",
          buttonText: "Prêt, Commencer la Détection",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "Détection Faciale",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title:
            "Ensuite, nous allons entrer dans la phase de détection faciale",
          text:
            "Veuillez lire attentivement les instructions d'image ci-dessous, et après préparation, cliquez sur le bouton ci-dessous pour effectuer la détection faciale",
          buttonText: "Prêt, Commencer la Détection",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "Évaluation des Compétences",
          title: "Veuillez répondre aux questions de l'intervieweur",
          text: "Veuillez répondre aux questions de l'intervieweur",
          buttonText: "Répondre Maintenant",
          imgUrlList: []
        });
      }
    }
  }

  // !印尼语的默认配置
  static getDefaultSectionPageForIndonesian(
    type: SectionPageType,
    psyc?: TacMind
  ) {
    switch (type) {
      case SectionPageType.Color: {
        return new SectionConfig().assign({
          sectionName: "Deteksi Warna",
          title: "Selanjutnya, kita akan melakukan tes deteksi warna",
          text:
            "Silakan pilih jawaban berdasarkan angka atau pola pada kartu.<br/>Grup ini memiliki batas waktu; jawab dalam waktu yang diberikan, atau sistem akan otomatis melanjutkan ke pertanyaan berikutnya.",
          buttonText: "Mulai",
          imgUrlList: [
            "https://oss.hina.com/app/test/2023/09/20/cb4e116c14fa47be41c041e0f2972682.jpeg"
          ]
        });
      }
      case SectionPageType.Psyc: {
        return new SectionConfig().assign({
          sectionName: psyc?.name || "",
          title: `Selanjutnya, kita akan melakukan ${psyc?.name || ""}`,
          text: psyc?.introducer || "",
          buttonText: "Mulai Penilaian",
          imgUrlList: [psyc?.introducerImg]
        });
      }
      case SectionPageType.Body: {
        return new SectionConfig().assign({
          sectionName: "Deteksi Tubuh",
          needSectionPage: true,
          sectionKey: "bodyDetection",
          sectionType: 1,
          title: "Selanjutnya, kita akan memasuki fase deteksi tubuh",
          text:
            "Silakan tonton video panduan deteksi tangan, dan setelah siap, klik tombol di bawah untuk melakukan deteksi tubuh",
          buttonText: "Siap, Mulai Deteksi"
        });
      }
      case SectionPageType.Finger: {
        return new SectionConfig().assign({
          sectionName: "Deteksi Tangan",
          needSectionPage: true,
          sectionKey: "handDetection",
          sectionType: 1,
          title: "Selanjutnya, kita akan memasuki fase deteksi tangan",
          text:
            "Silakan tonton video panduan deteksi tangan, dan setelah siap, klik tombol di bawah untuk melakukan deteksi tangan",
          buttonText: "Siap, Mulai Deteksi",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Face: {
        return new SectionConfig().assign({
          sectionName: "Deteksi Wajah",
          needSectionPage: true,
          sectionKey: "faceDetection",
          sectionType: 1,
          title: "Selanjutnya, kita akan memasuki fase deteksi wajah",
          text:
            "Silakan baca dengan seksama petunjuk gambar di bawah ini, dan setelah siap, klik tombol di bawah untuk melakukan deteksi wajah",
          buttonText: "Siap, Mulai Deteksi",
          imgUrlList: [
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper1.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper2.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper3.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper4.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper5.png",
            "https://oss.hina.com/aiInterview/static/mp/handtest/pic3/swiper6.png"
          ]
        });
      }
      case SectionPageType.Questions: {
        return new SectionConfig().assign({
          sectionName: "Evaluasi Kemampuan",
          title: "Silakan jawab pertanyaan dari pewawancara",
          text: "Silakan jawab pertanyaan dari pewawancara",
          buttonText: "Jawab Sekarang",
          imgUrlList: []
        });
      }
    }
  }

  // !根据语言获取对应的默认配置
  static getDefaultSectionPageByLang(
    type: SectionPageType,
    lang: number,
    psyc?: TacMind
  ) {
    switch (lang) {
      case 0:
      case 8:
      case 9:
        return ExamComponent.getDefaultSectionPage(type, psyc);
      case 1:
        return ExamComponent.getDefaultSectionPageForEnglish(type, psyc);
      case 2:
        return ExamComponent.getDefaultSectionPageForMalay(type, psyc);
      case 3:
        return ExamComponent.getDefaultSectionPageForJapanese(type, psyc);
      case 4:
        return ExamComponent.getDefaultSectionPageForVietnamese(type, psyc);
      case 5:
        return ExamComponent.getDefaultSectionPageForKorean(type, psyc);
      case 6:
        return ExamComponent.getDefaultSectionPageForFrench(type, psyc);
      case 7:
        return ExamComponent.getDefaultSectionPageForIndonesian(type, psyc);
      default:
        return ExamComponent.getDefaultSectionPage(type, psyc);
    }
  }

  // !在第三步跳转到第四步的时候，把老版本 V1.0 的相关信息转换为 V1.5 新版本的信息
  static resetDataByExamV2(exam: ExamComponent, examV2: ExamV2Custom) {
    exam.examInfo.assign({
      name: examV2.name,
      remark: examV2.remark,
      positionId: examV2.positionId,
      innerName: examV2.innerName
    });
    exam.isTesting = examV2.isTesting;
    const hasVideoQuestion =
      examV2.isRandomQuestions === 1
        ? examV2.examRandomConfigList.find(
            item => item.questionType === EnumQuestionType.EnumQuestionTypeVideo
          )
        : examV2.questionSelectedList.find(
            item => item.questionType === EnumQuestionType.EnumQuestionTypeVideo
          );
    const params: any = {
      lang: examV2.lang,
      applicationRuleList: examV2.applicationRuleList?.map((item: any) =>
        new ApplicationRule().assign(item)
      ),
      scoreConfig: new ScoreConfig().assign({
        examScene: examV2.examScene,
        dimensionGroupNormScoreType: examV2.dimensionGroupNormScoreType
      }),
      replacementDetection: new VideoDetection().assign({
        use: examV2.replacePersonCheck
      }),
      certPhotoCapture: new CertPhotoCapture().assign({
        use: examV2.needSubmitPhoto,
        configData: new CertPhotoCaptureConfig().assign(examV2.photoConfig)
      }),
      dimensions: new Dimension().assign({
        dimensionConfigList: examV2.examDimensionConfigList.map(item =>
          new DimensionConfig().assign(item)
        )
      }),
      questions: new Question().assign({
        use: 1,
        componentSort: 0,
        configData: new QuestionConfig().assign({
          questionRandomSort: examV2.questionRandomSort,
          questionRandomSortRange: examV2.questionRandomSortRange,
          needSaveVideoBeforeAutoSubmit: examV2.needSaveVideoBeforeAutoSubmit,
          needParseResume: examV2.needParseResume,
          closeQuestionVideo: examV2.closeQuestionVideo,
          useDeepChat: exam.examVersionInfo.questions.configData.useDeepChat
        }),
        questionConfigList: examV2.examQuestionConfigList
          .filter(item => item.questionId)
          .map(item => {
            const scoreConfigList = examV2.examScoreConfigList.filter(
              sItem => sItem.questionId === item.questionId
            );
            const question = examV2.questionSelectedList.find(
              sItem => sItem.questionId === item.questionId
            );

            // ! 新版本 exam 该题目的信息
            const examQuestionItem = exam.examVersionInfo.questions.questionConfigList?.find(
              aItem => {
                return aItem.questionId === item.questionId;
              }
            );

            // 抽题组卷中的视频题维度得分，要从抽题组卷结构体中获取
            const randomGroup = examV2.examRandomConfigList.find(rItem =>
              rItem.questionIdList.includes(item.questionId)
            );

            const randomVideoScoreConfig =
              randomGroup?.dimensionScoreConfigList.map(dItem => {
                return new DimensionScore().assign({
                  dimensionKey: dItem.dimensionKey,
                  videoQuestionScore: dItem.dimensionScore,
                  dimensionScore: dItem.dimensionScore
                });
              }) || [];

            const randomGroupLang = randomGroup?.examQuestionConfig.lang;

            const isRandomGroup = examV2.isRandomQuestions === 1;

            return new QuestionItem().assign({
              lang: isRandomGroup ? randomGroupLang : item?.lang || 0,
              questionId: item.questionId,
              questionType: item.questionType || question?.questionType,
              preparationTime:
                randomGroup?.examQuestionConfig.preparationTime ??
                item.preparationTime,
              answerTime:
                randomGroup?.examQuestionConfig.answerTime ?? item.answerTime,
              submitNumberLimit:
                randomGroup?.examQuestionConfig.submitNumberLimit ??
                item.submitNumberLimit,
              openPreparationTimeSound:
                randomGroup?.examQuestionConfig.openPreparationTimeSound ??
                item.openPreparationTimeSound,
              needAskAppend: item.needAskAppend,
              appendMaxAskNumber:
                examQuestionItem?.appendAskConfig?.appendMaxAskNumber || 0,
              appendScorePercent:
                examQuestionItem?.appendAskConfig?.appendScorePercent || 1,
              appendAskConfig: examQuestionItem?.appendAskConfig,
              dimensionScoreList:
                examV2.isRandomQuestions === 1 &&
                (question?.isVideoQuestion() || question?.isMP3())
                  ? randomVideoScoreConfig
                  : scoreConfigList
            });
          })
          .sort((q1, q2) => {
            return (
              examV2.questionIdList.indexOf(Number(q1.questionId)) -
              examV2.questionIdList.indexOf(Number(q2.questionId))
            );
          }),
        isRandomQuestion: examV2.isRandomQuestions,
        randomConfigList: examV2.examRandomConfigList.map(item =>
          new RandomConfig().assign({
            ...item,
            dimensionScoreList: item.dimensionScoreConfigList
          })
        )
      }),
      sectionPageConfig: new Section().assign({
        use: examV2.newSectionProgressUi === 1 ? 1 : 2,
        type:
          examV2.newSectionProgressUi !== 1
            ? 0
            : examV2.newSectionProgressUiVersion === 0
            ? 1
            : 2
      }),
      questionSelectedList: examV2.questionSelectedList
    };
    if (!hasVideoQuestion) {
      params.readingDetection = { use: 2 };
    }
    exam.examVersionInfo.assign(params);

    return exam;
  }

  // ! 新版版（组件化版本）的面试结构转换为老版(V1.0)的面试结构
  static getExamV2(exam: ExamComponent) {
    return new ExamV2Custom().assign({
      lang: exam.examVersionInfo.lang,
      applicationRuleList: exam.examVersionInfo.applicationRuleList,
      isTesting: exam.isTesting,
      examId: exam.metaInfo.examId,
      name: exam.examInfo.name,
      innerName: exam.examInfo.innerName,

      remark: exam.examInfo.remark,
      connectCode: exam.metaInfo.connectCode,
      positionName: exam.examInfo.positionName,
      positionId: exam.examInfo.positionId,
      paramList: exam.examVersionInfo.paramList,

      noEnding: exam.examVersionInfo.timeLimitConfig.noEnding,
      beginTime: exam.examVersionInfo.timeLimitConfig.beginTime,
      endTime: exam.examVersionInfo.timeLimitConfig.endTime,
      timeLimitGiveUp:
        exam.examVersionInfo.timeLimitConfig.timeLimitGiveUp || -1,
      giveUpSignIn: exam.examVersionInfo.timeLimitConfig.giveUpSignIn,
      giveUpNotSignIn: exam.examVersionInfo.timeLimitConfig.giveUpNotSignIn,
      timeLimitExam: exam.examVersionInfo.timeLimitConfig.timeLimitExamTemp,
      timeLimitExamType: exam.examVersionInfo.timeLimitConfig.timeLimitExamType,
      canOpenJoin: exam.examVersionInfo.timeLimitConfig.canOpenJoin,

      testExamId: exam.examVersionInfo.testExamConfig.configData.testExamId,

      publicityPageContent:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageContent,
      publicityPageVideoUrl:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoUrl,
      publicityPageVideoUse:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoUse,
      publicityPageVideoAutoplay:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoAutoplay,
      publicityPageVideoUseWhich:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoUseWhich,
      publicityPageVideoCoverUrl:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoCoverUrl,
      publicityPageVideoCoverUse:
        exam.examVersionInfo.publicityPageConfig.configData
          .publicityPageVideoCoverUse,

      descBefore: exam.examVersionInfo.descBefore.configData.descBefore,
      descBeforeShowWay:
        exam.examVersionInfo.descBefore.configData.descBeforeShowWay,
      descBeforeShowWayImgUrl:
        exam.examVersionInfo.descBefore.configData.descBeforeShowWayImgUrl,
      descBeforeVideoMustPlay:
        exam.examVersionInfo.descBefore.configData.descBeforeVideoMustPlay,

      descAfter: exam.examVersionInfo.descAfter.configData.descAfter,
      descAfterShowWay:
        exam.examVersionInfo.descAfter.configData.descAfterShowWay,
      descAfterShowWayImgUrl:
        exam.examVersionInfo.descAfter.configData.descAfterShowWayImgUrl,

      repeatAnswer:
        exam.examVersionInfo.repeatAnswerConfig.repeatAnswerLimit === 0,
      repeatAnswerLimit:
        exam.examVersionInfo.repeatAnswerConfig.repeatAnswerLimit,

      screenshotCheck: exam.examVersionInfo.screenshotDetection.use,
      screenshotCheckLimit:
        exam.examVersionInfo.screenshotDetection.configData.violationNumber,
      watermarkType:
        exam.examVersionInfo.watermark.use === 1
          ? exam.examVersionInfo.watermark.configData.contentType
          : 0,
      screenshotProtect: exam.examVersionInfo.screenshotDetection.configData
        .protect
        ? 1
        : 2,
      screenshotWhiteList:
        exam.examVersionInfo.screenshotDetection.configData.whiteList,
      mobileJoinCountCheck: exam.examVersionInfo.jumpOutDetection.use,
      mobileJoinCountCheckLimit:
        exam.examVersionInfo.jumpOutDetection.configData.violationNumber,

      isRandomQuestions: exam.examVersionInfo.questions.isRandomQuestion,
      questionRandomSort:
        exam.examVersionInfo.questions.configData.questionRandomSort,
      questionRandomSortRange:
        exam.examVersionInfo.questions.configData.questionRandomSortRange,
      questionIdList: exam.examVersionInfo.questions.questionConfigList.map(
        item => item.questionId
      ),
      examRandomConfigList: exam.examVersionInfo.questions.randomConfigList.map(
        item => {
          const params = exam.examVersionInfo.questions.questionConfigList.find(
            child => item.questionIdList.includes(child.questionId)
          );
          return new StructExamRandomConfig().assign({
            ...item,
            dimensionScoreConfigList: item.dimensionScoreList,
            examQuestionConfig: {
              lang: params?.lang || 0,
              appendAskConfig: params?.appendAskConfig,
              preparationTime: params?.preparationTime,
              answerTime: params?.answerTime,
              submitNumberLimit: params?.submitNumberLimit,
              openPreparationTimeSound: params?.openPreparationTimeSound
            }
          });
        }
      ),
      examScoreConfigList: exam.examVersionInfo.questions.questionConfigList.reduce(
        (pre: any[], item) => {
          const list = item.dimensionScoreList.map(dItem => ({
            ...dItem,
            questionId: item.questionId
          }));

          return pre.concat(list);
        },
        []
      ),
      examQuestionConfigList: exam.examVersionInfo.questions.questionConfigList.map(
        item =>
          new StructExamQuestionConfig().assign({
            ...item,
            needAskAppend: item.appendAskConfig.enableAppendAsk
          })
      ),
      closeQuestionVideo:
        exam.examVersionInfo.questions.configData.closeQuestionVideo,
      needSaveVideoBeforeAutoSubmit:
        exam.examVersionInfo.questions.configData.needSaveVideoBeforeAutoSubmit,
      needParseResume:
        exam.examVersionInfo.questions.configData.needParseResume,

      dimensionKeyList: exam.examVersionInfo.dimensions.dimensionConfigList.map(
        item => item.dimensionKey
      ),
      examDimensionConfigList:
        exam.examVersionInfo.dimensions.dimensionConfigList,

      livenessRecognition: exam.examVersionInfo.livenessRecognition.use,
      lrType: exam.examVersionInfo.livenessRecognition.configData.lrType,
      lrRetryNumberLimit:
        exam.examVersionInfo.livenessRecognition.configData.lrRetryNumberLimit,
      lrErrorAutoSubmit:
        exam.examVersionInfo.livenessRecognition.configData.lrErrorAutoSubmit,

      bgCheckProductId:
        exam.examVersionInfo.bgCheck.configData.bgCheckProductId,
      replacePersonCheck: exam.examVersionInfo.replacementDetection.use,

      wxminiDeviceDetection: exam.examVersionInfo.deviceDetection.configData
        .deviceDetection
        ? 1
        : 2,
      wxminiNoiseDetection: exam.examVersionInfo.deviceDetection.configData
        .noiseDetection
        ? 1
        : 2,

      dimensionGroupConfigList:
        exam.examVersionInfo.dimensions.dimensionGroupList,

      fingerTest: exam.examVersionInfo.handDetection.use,
      fingerConfig: new FingerConfig().assign(
        exam.examVersionInfo.handDetection.configData
      ),

      colorTest: exam.examVersionInfo.colorDetection.use,

      tacPsycGaugeConfigList: exam.examVersionInfo.tacPsycGauge.configDataList.map(
        item => {
          return new TacMindConfig().assign(item);
        }
      ),

      gameTestConfig: exam.examVersionInfo.game.gameTypeList,

      examScene: exam.examVersionInfo.scoreConfig.examScene,
      dimensionGroupNormScoreType:
        exam.examVersionInfo.dimensions.dimensionGroupList[0]?.normScoreType,

      virId: exam.examVersionInfo.virConfig.virId,

      faceDetection: exam.examVersionInfo.faceDetection.use,
      needSubmitPhoto: exam.examVersionInfo.certPhotoCapture.use,
      photoConfig: exam.examVersionInfo.certPhotoCapture.configData,

      newSectionProgressUi:
        exam.examVersionInfo.sectionPageConfig.use === 1 ? 1 : 0,
      newSectionProgressUiVersion:
        exam.examVersionInfo.sectionPageConfig.type === 2 ? 1 : 0,

      questionSelectedList: exam.examVersionInfo.questionSelectedList
    });
  }

  static create(params: ExamComponent) {
    return request.postInterviewApi("hr/exam/create", params).then(res => {
      return res.data;
    });
  }

  static get(id: number, ver?: number) {
    return request
      .postInterviewApi("hr/exam/get", { examId: id, examVersionId: ver })
      .then(res => {
        return new ExamComponent().assign(res.data.data);
      });
  }

  static checkUpdate(params: any) {
    return request.postInterviewApi("hr/exam/updateCheck", params).then(res => {
      return res.data;
    });
  }

  static createNewVersion(params: ExamComponent) {
    const p = {
      examId: params.metaInfo.examId,
      examVersionId: params.metaInfo.examVersionId,
      ...params
    };

    return request.postInterviewApi("hr/exam/newVersion", p).then(res => {
      return res.data;
    });
  }

  static update(params: ExamComponent) {
    const p = {
      examId: params.metaInfo.examId,
      examVersionId: params.metaInfo.examVersionId,
      ...params
    };

    return request.postInterviewApi("hr/exam/update", p).then(res => {
      return res.data;
    });
  }

  static updateName(params: ExamUpdateName) {
    return request.postInterviewApi("hr/exam/updateName", params).then(res => {
      return res.data;
    });
  }

  static copy(params: ExamUpdateName) {
    return request.postInterviewApi("hr/exam/copy", params).then(res => {
      return res.data;
    });
  }

  static delete(id: number) {
    return request
      .postInterviewApi("hr/exam/delete", { examId: id })
      .then(res => {
        return res.data;
      });
  }

  static hasEmail(id: number) {
    return request
      .postInterviewApi("hr/exam/hasEmail", { examId: id })
      .then(res => {
        return res.data;
      });
  }
}
